export const useMainNavStore = defineStore('mainNav', {
  state: () => ({
    isOpen: false, // mobile drawer open state
    activeNavItemIndex: null, // desktop drawer open topMenu index
    mainNav: [],
    benefits: [],
    helpNav: null,
    alternates: {},
    contactWidget: null,
  }),

  getters: {
    getMainNav: (state) => state.mainNav,
    getAlternates: (state) => state.alternates,
    hasAlternates: (state) => {
      try {
        return state.alternates && Object.entries(state.alternates).length > 0;
      } catch (e) {
        return false;
      }
    },
  },

  actions: {
    open() {
      const { $_gtm } = useNuxtApp();

      $_gtm.push({
        event: 'gaEvent',
        event_name: 'navigation_mobile_unfold',
        navigation: {
          navigation_interaction: 'unfold',
          navigation_item: 'mobile_menu',
          event_category: 'Navigation',
          event_action: 'Mobile Menu',
          event_label: 'unfold',
        },
      });

      this.isOpen = true;
    },

    close() {
      const { $_gtm } = useNuxtApp();

      $_gtm.push({
        event: 'gaEvent',
        event_name: 'navigation_mobile_fold',
        navigation: {
          navigation_interaction: 'fold',
          navigation_item: 'mobile_menu',
          event_category: 'Navigation',
          event_action: 'Mobile Menu',
          event_label: 'fold',
        },
      });

      this.isOpen = false;
    },

    init(mainNav) {
      this.mainNav = mainNav;
    },

    setActiveNavItemIndex(index) {
      this.activeNavItemIndex = index;
    },

    setHelpNav(helpNav) {
      this.helpNav = helpNav;
    },

    setBenefitsNav(benefits) {
      this.benefits = benefits;
    },

    setAlternates(alternates) {
      if (alternates.length === 0) {
        const { locales } = useI18n();
        const { $switchLocalePath } = useNuxtApp();

        alternates = locales.value.reduce((acc, cur) => {
          acc[cur.code] = $switchLocalePath(cur.code);

          return acc;
        }, {});
      }
      this.alternates = alternates === null ? {} : alternates;
    },

    setContactWidget(contactWidget) {
      this.contactWidget = contactWidget;
    },
  },
});
